import { SearchPage } from 'components/general-settings/search-page/SearchPage'
import { useEffect, useState } from 'react'
import { useFetch } from 'services/useFetch'
import { API_SEARCH_PAGE } from 'services/apiSearchPage'
import {
    capitalize,
    constructOptionMultipleSelect,
    constructOptionsSelect,
    convertErrorMessage,
    getValueFromArray,
} from 'utils/utils'
import { Alert } from 'avo-ui'
import { INITIAL_STATE, GET_ITEM_FIELD_NAME, GET_FIELD_NAME } from 'configs/general-settings/configFormSearchPage'

export const SearchPageContainer = () => {
    const [reload, setReload] = useState(false)
    const [searchPageDetail, setSearchPageDetail] = useState(INITIAL_STATE)
    const [errorForm, setErrorForm] = useState({})
    const { fetching: getSearchPageDetail, isLoading } = useFetch(API_SEARCH_PAGE.DETAIL)
    const { fetching: updateSearchPage, isLoading: isUpdating } = useFetch(API_SEARCH_PAGE.UPDATE)

    const onChangeForm = (item) => {
        setSearchPageDetail({ ...searchPageDetail, ...item })
    }

    const validateForm = () => {
        const validatePromos = () => {
            const result = []
            searchPageDetail?.promo_data?.promos?.map((item, index) => {
                Object.keys(item).forEach((key) => {
                    if (GET_ITEM_FIELD_NAME[key] && !item[key]) {
                        result.push({ index, key, message: `${GET_ITEM_FIELD_NAME[key]} wajib diisi` })
                    }
                })
            })
            return result
        }

        return new Promise((resolve, reject) => {
            const errors = {}
            Object.entries(searchPageDetail).forEach(([key, item]) => {
                const result = {}
                Object.keys(item).forEach((i) => {
                    if (!searchPageDetail[key][i] || searchPageDetail[key][i]?.length === 0) {
                        result[i] = `${GET_FIELD_NAME[key][i]} wajib diisi`
                    } else if (i === 'promos' && validatePromos()?.length) {
                        result['promos_detail'] = validatePromos()
                    }
                })
                if (Object.keys(result).length) errors[key] = result
            })

            setErrorForm(errors)
            if (!Object.keys(errors).length) resolve()
        })
    }

    const onSubmit = () => {
        validateForm().then(() => {
            const { promos, ...promoRest } = searchPageDetail?.promo_data
            const { brand_ids, ...brandRest } = searchPageDetail?.brand_data
            const { product_ids, ...productRest } = searchPageDetail?.product_data
            const payload = {
                promo_data: {
                    ...promoRest,
                    promos: promos?.map((item, index) => {
                        return {
                            ...item,
                            type: item?.type?.value,
                            sequence: index,
                        }
                    }),
                },
                brand_data: {
                    ...brandRest,
                    brand_ids: getValueFromArray(brand_ids, 'value'),
                },
                product_data: {
                    ...productRest,
                    product_ids: getValueFromArray(product_ids, 'value'),
                },
            }
            updateSearchPage(payload)
                .then(() => {
                    setReload(!reload)
                    return Alert({
                        icon: 'success',
                        title: 'Success',
                        message: 'Search Page Updated !',
                    })
                })
                .catch((error) => setErrorForm(convertErrorMessage(error?.data, GET_FIELD_NAME, GET_ITEM_FIELD_NAME)))
        })
    }

    useEffect(() => {
        getSearchPageDetail().then((response) => {
            const data = { ...response?.data }
            const { promos, ...promoRest } = data?.promo_data
            const { brands, ...brandRest } = data?.popular_brand
            const { products, ...productRest } = data?.popular_product
            const newDetail = {
                promo_data: {
                    ...promoRest,
                    promos: promos?.map((item) => {
                        return {
                            ...item,
                            type: { label: capitalize(item?.type), value: item?.type },
                        }
                    }),
                },
                brand_data: {
                    ...brandRest,
                    brand_ids: constructOptionsSelect(brands, 'name', 'id'),
                },
                product_data: {
                    ...productRest,
                    product_ids: constructOptionMultipleSelect(products, 'name', 'id'),
                },
            }
            setSearchPageDetail(newDetail)
        })
    }, [reload])

    const props = {
        sectionProps: {
            searchPageDetail,
            onChangeForm,
            errorForm,
        },
        isLoading,
        isUpdating,
        onSubmit,
    }

    return <SearchPage {...props} />
}
